import { useSelector } from "react-redux";
import { TrackTable } from "./TrackTable";

export const TrackItem = () => {
  const masterLibraryData = useSelector((state) => state.audioEngineer)

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left border-separate border-spacing-y-2">
        <TrackTable libraryData={masterLibraryData} />
      </table>
    </div>
  );
};
